import { createContext, useContext } from 'react';
type WorksheetAccessContextType = {
  isPro: boolean;
};
const worksheetAccessContext = createContext<WorksheetAccessContextType>({
  isPro: false
});
export const WorksheetAccessContext = ({
  isPro,
  children
}: {
  isPro: boolean;
  children: React.ReactNode;
}) => {
  return <worksheetAccessContext.Provider value={{
    isPro
  }} data-sentry-element="unknown" data-sentry-component="WorksheetAccessContext" data-sentry-source-file="WorksheetAccessContext.tsx">
      {children}
    </worksheetAccessContext.Provider>;
};
export const useWorksheetAccessContext = () => {
  const context = useContext(worksheetAccessContext);
  if (context == null) {
    throw new Error('WorksheetAccessContext not found');
  }
  return context;
};